import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useState } from "react";
import ScorecardFiltersViewModel from "../../Viewmodels/ScorecardFiltersViewModel";
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';

interface IActiveFiltersDialogProps {
    open: boolean;
    setOpen: (isOpen: boolean) => void;
    currentActiveStatus: string;
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function ActiveFiltersDialog({ open, setOpen, currentActiveStatus, changeFilter }: IActiveFiltersDialogProps) {
    const [activeStatus, setActiveStatus] = useState(currentActiveStatus);

    const activeStatusList = ['Active', 'Inactive', 'Never Been Active']

    const confirm = () => {
        changeFilter('activeStatus', activeStatus);
        setOpen(false);
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} fullWidth maxWidth="sm" >
            <DialogTitle>Client Filters</DialogTitle>
            <DialogContent>
                <Grid container height="100%">
                    <Grid container size={12}>
                        <Grid size={12} >
                            <Select
                                value={activeStatus}
                                onChange={(e) => setActiveStatus(e.target.value as string)}
                                endAdornment={activeStatus &&
                                    <IconButton onClick={() => setActiveStatus('')} sx={{ marginRight: 2 }}>
                                        <ClearIcon />
                                    </IconButton>}
                                fullWidth>
                                {
                                    activeStatusList.map(item =>
                                        <MenuItem key={item} value={item}>{item}</MenuItem>)
                                }
                            </Select>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button onClick={confirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}